import { EventEmitter } from '@angular/core';
import { Component, OnInit, Input, Output } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-md-popover',
  templateUrl: './md-popover.component.html',
  styleUrls: ['./md-popover.component.scss'],
})
export class MdPopoverComponent implements OnInit {
 optionList: string[];

  constructor(private navParams: NavParams, public popoverController: PopoverController) { }

  ngOnInit() {
    this.optionList = this.navParams.get('optionListProp');
   // console.log("lista en md popover",this.optionList);
  }

  async onSelectAction(selectedValue: any) {
   // console.log(selectedValue)
   await this.popoverController.dismiss({ selectedValue });
  }

}
